export const ProductList = [
    {
        "filename": "greenstarimg1.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg2.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg3.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg4.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg5.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg6.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg7.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination",
            "island"
        ]
    },
    {
        "filename": "greenstarimg8.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination",
            "island",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg9.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg10.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg11.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "colorcoordination",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg12.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg13.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "woodgrain",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg14.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "colorcoordination",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg15.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination",
            "appliancecabinet",
            "island",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg16.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "appliancecabinet",
            "gloss",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg17.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg18.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "appliancecabinet",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg19.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg20.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "woodgrain",
            "colorcoordination",
            "island",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg21.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "appliancecabinet",
            "colorcoordination",
            "island"
        ]
    },
    {
        "filename": "greenstarimg22.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "appliancecabinet",
            "island"
        ]
    },
    {
        "filename": "greenstarimg23.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg24.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "appliancecabinet",
            "island",
            "woodgrain"
        ]
    },
    {
        "filename": "greenstarimg25.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "gloss",
            "appliancecabinet",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg26.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "appliancecabinet",
            "island",
            "matte",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg27.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "rustic",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg28.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "appliancecabinet",
            "island",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg29.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "colorcoordination",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg30.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg31.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg32.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg33.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg34.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg35.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg36.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "woodgrain",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg37.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "island"
        ]
    },
    {
        "filename": "greenstarimg38.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "island"
        ]
    },
    {
        "filename": "greenstarimg39.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "island"
        ]
    },
    {
        "filename": "greenstarimg40.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg41.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "woodgrain"
        ]
    },
    {
        "filename": "greenstarimg42.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "island",
            "gloss",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg43.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg44.webp",
        "tags": [
            "kitchencabinet",
            "island"
        ]
    },
    {
        "filename": "greenstarimg45.webp",
        "tags": [
            "kitchencabinet",
            "island"
        ]
    },
    {
        "filename": "greenstarimg46.webp",
        "tags": [
            "kitchencabinet",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg47.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "island"
        ]
    },
    {
        "filename": "greenstarimg48.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "island"
        ]
    },
    {
        "filename": "greenstarimg49.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg50.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg51.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg52.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg53.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg54.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss",
            "colorcoordination"
        ]
    },
    {
        "//": "Recurred and deleted",
        "filename": "greenstarimg55.webp",
        "tags": [
        ]
    },
    {
        "filename": "greenstarimg56.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "island",
            "appliancecabinet",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg57.webp",
        "tags": [
            "kitchencabinet",
            "island",
            "appliancecabinet",
            "gloss",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg58.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg59.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg60.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg61.webp",
        "tags": [
            "kitchencabinet",
            "island"
        ]
    },
    {
        "filename": "greenstarimg62.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "island",
            "woodgrain"
        ]
    },
    {
        "filename": "greenstarimg63.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "island",
            "woodgrain"
        ]
    },
    {
        "filename": "greenstarimg64.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "//": "Recurred and deleted",
        "filename": "greenstarimg65.webp",
        "tags": []
    },
    {
        "filename": "greenstarimg66.webp",
        "tags": [
            "systemcabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg67.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg68.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg69.webp",
        "tags": [
            "systemcabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg70.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg71.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg72.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg73.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg74.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg75.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg76.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg77.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg78.webp",
        "tags": [
            "systemcabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg79.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg80.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg81.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg82.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg83.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg84.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg85.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg86.webp",
        "tags": [
            "systemcabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg87.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg88.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg89.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg90.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg91.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg92.webp",
        "tags": [
            "systemcabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg93.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg94.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "appliancecabinet",
            "gloss",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg95.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "gloss",
            "glassdoor"
        ]
    },
    {
        "filename": "greenstarimg96.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg97.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "colorcoordination",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg98.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "gloss",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg99.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg100.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg101.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "appliancecabinet",
            "island",
            "rustic"
        ]
    },
    {
        "filename": "greenstarimg102.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "gloss",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg103.webp",
        "tags": [
            "kitchencabinet",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg104.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg105.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "island",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg106.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg107.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg108.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "colorcoordination",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg109.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg110.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg111.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg112.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte",
            "appliancecabinet",
            "island"
        ]
    },
    {
        "filename": "greenstarimg113.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg114.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "rustic",
            "appliancecabinet",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg115.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "glassdoor"
        ]
    },
    {
        "filename": "greenstarimg116.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg117.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg118.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "rustic",
            "colorcoordination",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg119.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "rustic",
            "popular"
        ]
    },
    {
        "filename": "greenstarimg120.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "appliancecabinet",
            "island",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg121.webp",
        "tags": [
            "bathroom"
        ]
    },
    {
        "filename": "greenstarimg122.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg123.webp",
        "tags": [
            "kitchencabinet",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg124.webp",
        "tags": [
            "kitchencabinet",
            "glassdoor",
            "systemcabinet",
            "rustic"
        ]
    },
    {
        "filename": "greenstarimg126.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg127.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg128.webp",
        "tags": [
            "kitchencabinet",
            "glassdoor",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg129.webp",
        "tags": [
            "kitchencabinet",
            "glassdoor",
            "matte",
            "colorcoordination"
        ]
    },
    {
        "filename": "greenstarimg130.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg131.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg132.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "island",
            "matte",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg133.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg134.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg135.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "rustic"
        ]
    },
    {
        "filename": "greenstarimg136.webp",
        "tags": [
            "systemcabinet"
        ]
    },
    {
        "filename": "greenstarimg137.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "island",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg138.webp",
        "tags": [
            "kitchencabinet",
            "glassdoor",
            "gloss"
        ]
    },
    {
        "filename": "greenstarimg139.webp",
        "tags": [
            "kitchencabinet",
            "ushape",
            "rustic"
        ]
    },
    {
        "filename": "greenstarimg140.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "matte",
            "appliancecabinet"
        ]
    },
    {
        "filename": "greenstarimg141.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg142.webp",
        "tags": [
            "kitchencabinet",
            "island",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg143.webp",
        "tags": [
            "kitchencabinet",
            "linear",
            "island",
            "matte"
        ]
    },
    {
        "filename": "greenstarimg144.webp",
        "tags": [
            "kitchencabinet",
            "lshape",
            "island",
            "matte"
        ]
    },
]